import { Drawer, Button } from '@perch-labs/shrike';
import { useState } from 'react';
import { useCopy } from '~/hooks';
import { FunnelTrack } from '~/typings/graphql';
import { Title, Description } from '../typography';
import { DrawerWrapper, ContentBlock, ButtonBlock, Header as DrawerHeader } from './drawer.style';

export const BottomDrawer: React.FC<{
  open?: boolean;
  onClick?: () => void;
  context?: { inputState?: string; availableState?: string; funnelTrack?: FunnelTrack };
}> = ({ open, onClick = () => {}, context }) => {
  const [openDrawer, setOpenDrawer] = useState(open || false);
  const copy = useCopy({}, () => defaultCopy(context));

  return (
    <Drawer
      preventDismissal
      isOpen={openDrawer}
      onClose={() => {
        setOpenDrawer(false);
      }}
      position="bottom"
      removeWhenClosed={false}
    >
      <DrawerWrapper>
        <ContentBlock>
          <DrawerHeader>
            <Title margin="12px 0">{copy.title}</Title>
            <Description>{copy.description}</Description>
          </DrawerHeader>
        </ContentBlock>
        <ButtonBlock>
          <Button margin={{ bottom: '16px' }} onClick={onClick} mode="primary">
            {copy.continueButton}
          </Button>
        </ButtonBlock>
      </DrawerWrapper>
    </Drawer>
  );
};

export const defaultCopy = (context?: {
  inputState?: string;
  availableState?: string;
  funnelTrack?: FunnelTrack;
}) => {
  const { inputState, availableState = 'Ohio', funnelTrack } = context || {};

  return funnelTrack === ('solar' as FunnelTrack)
    ? {
        title: `This version of our Community Solar program, made possible through our partnership with Google and EDP Renewables, is only available in ${availableState}.`,
        description: `But great news, we offer our standard Community Solar program in ${inputState}. You’ll still get savings on your energy bill and help with our mission to transition to 100% clean energy.`,
        continueButton: 'Continue to sign up',
      }
    : {
        title: `This version of our Community Solar program, made possible through our partnership with Google and EDP Renewables, is only available in ${availableState}.`,
        description:
          'But we’re always expanding to new states! Go ahead and create your account today and we’ll let you know when our Community Solar program is available in your area.',
        continueButton: 'Continue to sign up',
      };
};
